import { Config, NodeEnv } from 'types/config';

// these are variables that do not change according to the tenant
export const MAP_API = import.meta.env.VITE_APP_MAP_API;

export const CONFIG: Config = {
  NODE_ENV: (process.env.NODE_ENV ?? 'development') as NodeEnv,
  API_URL: import.meta.env.VITE_APP_API_URL,
  FORM_BUILDER_ADK_URL: import.meta.env.VITE_FORM_BUILDER_ADK_URL,
  ZIPY_API_KEY: import.meta.env.VITE_APP_ZIPY_API_KEY,
  PYLON_APP_ID: import.meta.env.VITE_APP_PYLON_APP_ID,
  MAP_API: import.meta.env.VITE_APP_MAP_API,
  APP_PLATFORM: import.meta.env.VITE_APP_PLATFORM,
  AMPLITUDE_KEY: import.meta.env.VITE_APP_AMPLITUDE_API_KEY,
  // SEGMENT_WRITE_KEY: import.meta.env.VITE_APP_SEGMENT_WRITE_KEY,
  // ANALYTICS_SEGMENT_WRITE_KEY: import.meta.env.VITE_APP_SEGMENT_WRITE_KEY,
  PROTOTYPE_URL: import.meta.env.VITE_APP_PROTOTYPE_URL,
  BASE_URL: import.meta.env.VITE_APP_BASE_URL,
} as const;
